import { Link } from "react-router-dom";

export default function NotFound() {
  return (
    <div className="min-h-[70vh] grid place-items-center px-6">
      <div className="text-center">
        <p className="text-sm uppercase tracking-[0.3em] text-slate-500">
          404
        </p>
        <h1 className="text-4xl font-display text-deep mt-4">
          This villa is off the map.
        </h1>
        <p className="text-slate-600 mt-3">
          Return to the curated stays and keep exploring.
        </p>
        <Link
          to="/"
          className="inline-flex mt-6 px-5 py-3 rounded-full border border-deep/20 text-sm uppercase tracking-[0.2em] text-deep hover:bg-deep hover:text-white"
        >
          Back to Home
        </Link>
      </div>
    </div>
  );
}
